// extracted by mini-css-extract-plugin
export default {"container":"Quotes_container__52CbV","body":"Quotes_body__kDxkn","textName":"Quotes_textName__C5JJ+","textEmail":"Quotes_textEmail__NMp9m","itemIconImg":"Quotes_itemIconImg__S7vER"};